var render = function render(){var _vm=this,_c=_vm._self._c;return _c('qrcode-vue',{attrs:{"value":_vm.url,"size":_vm.size}})
}
var staticRenderFns = []

export { render, staticRenderFns }